/* tslint:disable */
/* eslint-disable */
/**
 * Communication API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CertificateLanguage } from '../models';
// @ts-ignore
import type { CertificateUrlPublic } from '../models';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { FccLabelRequest } from '../models';
// @ts-ignore
import type { FccLabelResponse } from '../models';
/**
 * CommunicationApi - axios parameter creator
 */
export const CommunicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a pre-signed certificate PDF URL for the specified `orderId` and `language`. Optionally customize the filename using the `filename` query parameter.
         * @summary Retrieve a certificate for a specific order and language
         * @param {string} orderId The ID of the order for which to retrieve the certificate.
         * @param {CertificateLanguage} language The language in which the certificate should be generated.
         * @param {string} [filename] The filename of the certificate PDF. File extension will be ignored.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificate: async (orderId: string, language: CertificateLanguage, filename?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getCertificate', 'orderId', orderId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getCertificate', 'language', language)
            const localVarPath = `/communication/v1/certificate/{orderId}/{language}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get or Generate FCC labels based on the provided data.
         * @summary Get or Generate FCC labels
         * @param {FccLabelRequest} fccLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFccLabel: async (fccLabelRequest: FccLabelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fccLabelRequest' is not null or undefined
            assertParamExists('getFccLabel', 'fccLabelRequest', fccLabelRequest)
            const localVarPath = `/communication/v1/fccLabel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fccLabelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunicationApi - functional programming interface
 */
export const CommunicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunicationApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a pre-signed certificate PDF URL for the specified `orderId` and `language`. Optionally customize the filename using the `filename` query parameter.
         * @summary Retrieve a certificate for a specific order and language
         * @param {string} orderId The ID of the order for which to retrieve the certificate.
         * @param {CertificateLanguage} language The language in which the certificate should be generated.
         * @param {string} [filename] The filename of the certificate PDF. File extension will be ignored.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCertificate(orderId: string, language: CertificateLanguage, filename?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateUrlPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCertificate(orderId, language, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunicationApi.getCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get or Generate FCC labels based on the provided data.
         * @summary Get or Generate FCC labels
         * @param {FccLabelRequest} fccLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFccLabel(fccLabelRequest: FccLabelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FccLabelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFccLabel(fccLabelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommunicationApi.getFccLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommunicationApi - factory interface
 */
export const CommunicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunicationApiFp(configuration)
    return {
        /**
         * Returns a pre-signed certificate PDF URL for the specified `orderId` and `language`. Optionally customize the filename using the `filename` query parameter.
         * @summary Retrieve a certificate for a specific order and language
         * @param {CommunicationApiGetCertificateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCertificate(requestParameters: CommunicationApiGetCertificateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CertificateUrlPublic> {
            return localVarFp.getCertificate(requestParameters.orderId, requestParameters.language, requestParameters.filename, options).then((request) => request(axios, basePath));
        },
        /**
         * Get or Generate FCC labels based on the provided data.
         * @summary Get or Generate FCC labels
         * @param {CommunicationApiGetFccLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFccLabel(requestParameters: CommunicationApiGetFccLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<FccLabelResponse> {
            return localVarFp.getFccLabel(requestParameters.fccLabelRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCertificate operation in CommunicationApi.
 */
export interface CommunicationApiGetCertificateRequest {
    /**
     * The ID of the order for which to retrieve the certificate.
     */
    readonly orderId: string

    /**
     * The language in which the certificate should be generated.
     */
    readonly language: CertificateLanguage

    /**
     * The filename of the certificate PDF. File extension will be ignored.
     */
    readonly filename?: string
}

/**
 * Request parameters for getFccLabel operation in CommunicationApi.
 */
export interface CommunicationApiGetFccLabelRequest {
    readonly fccLabelRequest: FccLabelRequest
}

/**
 * CommunicationApi - object-oriented interface
 */
export class CommunicationApi extends BaseAPI {
    /**
     * Returns a pre-signed certificate PDF URL for the specified `orderId` and `language`. Optionally customize the filename using the `filename` query parameter.
     * @summary Retrieve a certificate for a specific order and language
     * @param {CommunicationApiGetCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCertificate(requestParameters: CommunicationApiGetCertificateRequest, options?: RawAxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).getCertificate(requestParameters.orderId, requestParameters.language, requestParameters.filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get or Generate FCC labels based on the provided data.
     * @summary Get or Generate FCC labels
     * @param {CommunicationApiGetFccLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFccLabel(requestParameters: CommunicationApiGetFccLabelRequest, options?: RawAxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).getFccLabel(requestParameters.fccLabelRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

